export default __webpack_public_path__ + "static/Staatliches-Regular-e754abc42c2903759785343181e024db.eot";